import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cfd36d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container py-10"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Declaração anual", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "* Limite de R$ 81.000,00", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recipe2" }, " Possuiu empregado no ano que você selecionou para declarar? ", -1))
const _hoisted_5 = { class: "flex text-sm items-center text-gray-600" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não", -1))
const _hoisted_7 = { class: "mx-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sim", -1))
const _hoisted_9 = { class: "next-step-button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Continuar", -1))

import { ref } from "vue";
import {
	useIonRouter,
	IonPage,
	IonContent,
	IonIcon,
	toastController,
	onIonViewWillEnter,
} from "@ionic/vue";
import { Form, Field } from "vee-validate";
import { arrowForwardOutline } from "ionicons/icons";

import Input from "@/components/base/Input.vue";
import Button from "@/components/Button.vue";
import BackHeader from "@/components/layouts/BackHeader.vue";
import { step1 } from "@/validations/annualStatementForm";
import Switcher from "@/components/Switcher.vue";
import { formattedIsMoney, removeMask } from "@/helpers/filters";
import { useServiceForm } from "@/composables/serviceForm";
import { useService } from "@/composables/services";
import { useUser } from "@/composables/user";

import api from "@/services/api/api";
import LoadingScreen from "@/components/LoadingScreen.vue";
import { format } from "v-money3";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnualStatement',
  setup(__props) {

const ionRouter = useIonRouter();
const { setFormData, clearForm, form } = useServiceForm();
const { getByServiceCode, service } = useService();
const { user } = useUser();
const loading = ref(true);
const hasEmployee = ref(false);

const formatForm = () => {
	setFormData(removeMask(form.value, ["cnpj"]));
	form.value.grossRevenue = format(form.value.grossRevenue);
	form.value.grossRevenue = formattedIsMoney(form.value.grossRevenue);
};

const onSubmit: any = async (formData: never) => {
	setFormData(formData);
	formatForm();
	await getByServiceCode("ANNUAL_STATEMENT");
	try {
		const { order } = await api.createOrder({
			serviceId: service.value.id,
			serviceCode: service.value.code,
			requestData: form.value,
		});

		return ionRouter.push(`/payments/${order.id}`);
	} catch (error: any) {
		const toast = await toastController.create({
			message: error.message,
			duration: 2000,
			color: "danger",
		});
		await toast.present();
	}
};
const loadData = async () => {
	loading.value = true;
	clearForm();
	if (user.value) form.value.cnpj = user.value.cnpj;
	loading.value = false;
};

onIonViewWillEnter(() => {
	loadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(BackHeader),
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(LoadingScreen)
        ]),
        _: 1
      }, 512), [
        [_vShow, loading.value]
      ]),
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_unref(Form), {
                  class: "grid gap-y-3 w-full",
                  "validation-schema": _unref(step1),
                  onSubmit: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(Input, {
                      type: "text",
                      name: "cnpj",
                      placeholder: "Cnpj *",
                      value: _unref(form)?.cnpj,
                      maska: "##.###.###/####-##",
                      disabled: ""
                    }, null, 8, ["value"]),
                    _createVNode(Input, {
                      type: "text",
                      name: "year",
                      placeholder: "Para que ano você quer declarar *",
                      value: _unref(form)?.year,
                      maska: "####"
                    }, null, 8, ["value"]),
                    _createVNode(Input, {
                      id: "grossRevenue",
                      type: "text",
                      name: "grossRevenue",
                      placeholder: "Receita bruta",
                      value: _unref(form)?.grossRevenue,
                      isMoney: ""
                    }, null, 8, ["value"]),
                    _hoisted_3,
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(Switcher, {
                          value: hasEmployee.value,
                          onToggle: _cache[0] || (_cache[0] = ($event: any) => (hasEmployee.value = !hasEmployee.value))
                        }, null, 8, ["value"]),
                        _createVNode(_unref(Field), {
                          name: "hasEmployee",
                          value: hasEmployee.value,
                          class: "hidden"
                        }, null, 8, ["value"])
                      ]),
                      _hoisted_8
                    ]),
                    _createVNode(Button, {
                      type: "submit",
                      class: "w-full",
                      onClick: onSubmit
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_unref(IonIcon), { icon: _unref(arrowForwardOutline) }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["validation-schema"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512), [
        [_vShow, !loading.value]
      ])
    ]),
    _: 1
  }))
}
}

})